import { useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import PromotoraService from '../../../services/promotoraService';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';
import { PromotoraJornadaDTO } from '../../../shared/dto/promotoraJornadaDTO';
import Spinner from '../../../shared/spinner';

interface PromotoraJornadaModalProps {
  show: boolean;
  promotora: PromotoraDTO | null;
  onHide: () => void;
}

function PromotoraJornadaModal({ show, promotora, onHide }: PromotoraJornadaModalProps) {
  const promotoraService = new PromotoraService();
  const [loading, setLoading] = useState(false);
  const [jornada, setJornada] = useState<PromotoraJornadaDTO[]>([]);
  const [erro, setErro] = useState('');

  const listarJornada = async () => {
    if (!promotora?.id) return;
    setLoading(true);
    setErro('');
    try {
      const response = await promotoraService.listarJornadaPromotora(promotora.id);
      setJornada(response.data || []);
    } catch (err: any) {
      setErro(err.response?.data || 'Erro ao listar jornada.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      listarJornada();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, promotora?.id]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Jornada da Promotora</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <strong>{promotora?.id} - {promotora?.nome}</strong>
          <span className="badge bg-secondary">{promotora?.statusGestaoDescricao || promotora?.statusGestao || '-'}</span>
        </div>
        {erro && <Alert variant="danger">{erro}</Alert>}
        {loading && <Spinner loading={loading} />}
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th id="App-header-table">Data e Hora</th>
                <th id="App-header-table">Usuário</th>
                <th id="App-header-table">Etapa</th>
                <th id="App-header-table">Observação</th>
              </tr>
            </thead>
            <tbody>
              {jornada.map((item) => (
                <tr key={item.id}>
                  <td>{item.dtEvento ? format(new Date(item.dtEvento), 'dd/MM/yyyy HH:mm') : ''}</td>
                  <td>{item.nomeUsuario || '-'}</td>
                  <td>{item.acaoDescricao || item.acao}</td>
                  <td>{item.observacao || '-'}</td>
                </tr>
              ))}
              {jornada.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center text-muted">Nenhum passo registrado.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <FontAwesomeIcon icon={faClose} className="me-2" />
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PromotoraJornadaModal;
